import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import { Subject, from } from 'rxjs';
import { mergeAll, map, share } from 'rxjs/operators';
import cloudPrint, { getDocs as getCloudPrintDocs } from "./cloud-print";
import Wet from "../wet";
import localPrint from "./local-print";
import { getUUID } from "../utils";
var MESSAGE_TYPE_INIT = 1;
var Print = /*#__PURE__*/function (_Wet) {
  _inheritsLoose(Print, _Wet);
  function Print(opt) {
    var _this$messages, _this$messages$pipe;
    var _this;
    if (opt === void 0) {
      opt = {};
    }
    var _opt = opt,
      _opt$url = _opt.url,
      url = _opt$url === void 0 ? 'wss://localhost:8080' : _opt$url,
      _opt$wetConnectRetry = _opt.wetConnectRetry,
      wetConnectRetry = _opt$wetConnectRetry === void 0 ? 0 : _opt$wetConnectRetry;
    _this = _Wet.call(this, {
      url: url,
      bussinessType: Print.bussinessType,
      initMessageType: MESSAGE_TYPE_INIT,
      name: '打印'
    }) || this;
    _this.messages$ = void 0;
    _this.input$ = void 0;
    _this.isReady = false;
    _this.WET_MAX_ATTEMPTS = wetConnectRetry;
    _this.messages$ = (_this$messages = _this.messages) === null || _this$messages === void 0 ? void 0 : (_this$messages$pipe = _this$messages.pipe) === null || _this$messages$pipe === void 0 ? void 0 : _this$messages$pipe.call(_this$messages, share());
    _this.input$ = _this.createPrint(_this.input);
    return _this;
  }
  var _proto = Print.prototype;
  _proto.createPrint = function createPrint(input) {
    var _this2 = this;
    var subject = new Subject();
    subject.pipe(map(function (printDatas) {
      return Array.isArray(printDatas) ? from(printDatas) : printDatas;
    }), mergeAll()).pipe(map(function (printData) {
      return _this2.printByType(printData);
    }), mergeAll(), map(function (printData) {
      return _extends({}, printData, {
        bussinessType: Print.bussinessType
      });
    })).pipe(this.stringify()).subscribe(function (data) {
      return input === null || input === void 0 ? void 0 : input.next(data);
    });
    return subject;
  };
  _proto.printData = function printData(result) {
    var _this$input;
    var _result$printConfig = result.printConfig,
      printConfig = _result$printConfig === void 0 ? {} : _result$printConfig,
      _result$data = result.data,
      data = _result$data === void 0 ? [] : _result$data;
    var printData = {
      businessType: 1,
      messageType: 3,
      configName: printConfig.configName,
      data: _extends({
        requestID: getUUID(),
        version: '1.0',
        cmd: 'print',
        task: {
          taskID: new Date().getTime() + getUUID(),
          documents: data
        }
      }, printConfig)
    };
    (_this$input = this.input) === null || _this$input === void 0 ? void 0 : _this$input.next(this.wetStringify(printData));
  };
  _proto.doPrint = function doPrint(data) {
    var _this$input$;
    (_this$input$ = this.input$) === null || _this$input$ === void 0 ? void 0 : _this$input$.next(data);
  };
  _proto.printByType = function printByType(printData) {
    if (printData.printConfig.printType === 'cloud') {
      return cloudPrint(printData);
    }
    return localPrint(printData);
  }

  // @ts-ignore
  ;
  _proto.isValidePrintData = function isValidePrintData(printData) {
    if (!printData.printConfig) {
      this.logger('打印数据错误，打印配置不存在');
      return false;
    }
    if (!printData.data || printData.data.length < 0) {
      this.logger('打印数据错误，打印数据不存在');
      return false;
    }
  };
  _proto.filterClourPrintDoc = function filterClourPrintDoc(printDatas) {
    if (printDatas === void 0) {
      printDatas = [];
    }
    try {
      return printDatas.map(function (printData) {
        return getCloudPrintDocs(printData);
      });
    } catch (err) {
      console.error(err);
      return [];
    }
  };
  _proto.subscribe = function subscribe(callback) {
    var _this$messages$;
    var subscription = (_this$messages$ = this.messages$) === null || _this$messages$ === void 0 ? void 0 : _this$messages$.subscribe({
      next: function next(data) {
        return callback({
          success: true,
          data: data
        });
      },
      error: function error(_error) {
        return callback({
          success: false,
          data: {},
          error: {
            message: _error.message
          }
        });
      },
      complete: function complete() {
        return callback({
          success: true,
          data: {},
          complete: true
        });
      }
    });
    return function () {
      subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
    };
  };
  return Print;
}(Wet);
Print.bussinessType = 1;
export default Print;